import { render } from "./index.vue?vue&type=template&id=4d5a5382"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/online-shop-support-edit/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d5a5382"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d5a5382', __exports__)) {
    api.reload('4d5a5382', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=4d5a5382", () => {
    api.rerender('4d5a5382', render)
  })

}


export default __exports__